import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import React from "react";
import { useHistory } from "react-router";

import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { BreedApi, BreedGridDto, BreedSearch } from "../../../../api";
import { Link } from "react-router-dom";

export interface IBreedsListPageProps {}

export const BreedsListPage: React.FunctionComponent<IBreedsListPageProps> = (props) => {
  const breedApi = useApiService(BreedApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: BreedGridDto) => (
          <ButtonContainer>
            <ViewButton minimal={true} onClick={() => history.push(`${ERoutes.breeds}/${row.breedId}/detail/view`)} />
            <EditButton minimal={true} onClick={() => history.push(`${ERoutes.breeds}/${row.breedId}/detail/edit`)} />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.BreedGroupLabel),
        fieldName: "breedGroupNumber",
        render: (row: BreedGridDto) => (
          <Link target="_blank" to={`${ERoutes.breedGroups}/${row.breedGroupId}/detail/view`}>
            {row.breedGroupFullName}
          </Link>
        ),
      },
    ],
    [history, t]
  );

  const addItem = React.useCallback(() => {
    history.push(`${ERoutes.breeds}/${0}/detail/edit`);
  }, [history]);

  const searchFunction = React.useCallback(
    (sObj) => breedApi.baseSearch(BreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [breedApi, currentLanguage.languageId]
  );

  const exportFunction = React.useCallback(
    (sObj) => breedApi.exportXlsFile(BreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [breedApi, currentLanguage.languageId]
  );

  const searchCriteriasFunction = React.useCallback(() => breedApi.getSearchCriterias(true), [breedApi]);

  return (
    <>
      <SearchTablePage
        columns={columns}
        getCriteriasFunction={searchCriteriasFunction}
        searchFunction={searchFunction}
        exportFunction={exportFunction}
        addFunc={addItem}
        sortKeys={{ name: "ASC" }}
        breadCrumbs={[{ text: t(ETLCodes.Breeds) }]}
      />
    </>
  );
};
